/**
 * The pivot tables the API keys on `id` rather than `uuid`. `expensables` is the name a build from
 * before MDC-3686 synced `inventoriables` under: its queued writes still carry that name after the
 * app updates, and still upload to `/expensables`, which the backend keeps for them.
 */
const ID_KEYED_PIVOTS: ReadonlySet<string> = new Set(['fileables', 'costables', 'inventoriables', 'expensables']);

export const isIdKeyedPivot = (tableName: string): boolean => ID_KEYED_PIVOTS.has(tableName);

export const getIdColumnFromTable = (data: { id: string; uuid: string }, tableName: string): string => {
  if (isIdKeyedPivot(tableName)) {
    return data.id;
  }
  return data.uuid;
};
